'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { NEW_TAB, SECONDARY_BUTTON_STYLE, TARGET_BLANK, TARGET_SELF } from '../../../../constants';
import { ColoredTextLink } from '../../../ColoredTextLink';
import type { StoreCardData } from '../types';

import './styles.scss';

export function FaqStoreCard({ cityState, address, badges, phoneNumber, cta }: StoreCardData) {
    const cityStateHref = cityState.link?.webUrl ?? '';
    const ctaHref = cta?.link?.webUrl ?? '';
    const ctaTarget = cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF;

    return (
        <div className="faq-store-card">
            <ColoredTextLink className="faq-store-card__headline" href={cityStateHref} color="Dark Grey">
                {cityState.actionText}
            </ColoredTextLink>
            <div className="faq-store-card__text">
                <TextPassage>{address}</TextPassage>
                <ColoredTextLink href={`tel:${phoneNumber}`} color="Dark Grey">
                    {phoneNumber}
                </ColoredTextLink>
            </div>
            {badges?.length ? (
                <div className="faq-store-card__badges">
                    {badges.map(({ text }, index) => (
                        <TextPassage className="faq-store-card__badge" size="sm" key={`${text}-${index}`}>
                            {text}
                        </TextPassage>
                    ))}
                </div>
            ) : null}
            {cta && (
                <Link prefetch={false} href={ctaHref} target={ctaTarget} rel="noopener noreferrer">
                    <Button variant={SECONDARY_BUTTON_STYLE} text={cta.text} size="sm" />
                </Link>
            )}
        </div>
    );
}
